import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { resetPassword } from '../api/resetPassword';

export function ResetPassword() {
  const { token } = useParams();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const passwordsMatch = password && password === confirm;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordsMatch) return;

    setLoading(true);
    try {
      await resetPassword(token, { password });
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset Password"
      subtitle="Create a new password to regain access to your account."
    >
      {success ? (
        <div className="text-center space-y-4">
          <p className="text-sm text-gray-700">Your password has been reset successfully.</p>
          <Link
            to="/account/login"
            className="inline-block text-[#AC3F1E] font-semibold hover:underline"
          >
            Return to Login
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
            <input
              type="password"
              minLength={6}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm New Password
            </label>
            <input
              type="password"
              minLength={6}
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••"
              className="w-full border border-gray-300 px-4 py-2 rounded-md focus:outline-none focus:border-[#AC3F1E]"
            />
          </div>

          {!passwordsMatch && confirm && (
            <p className="text-xs text-red-500">Passwords do not match.</p>
          )}

          <button
            type="submit"
            disabled={loading || !passwordsMatch}
            className="w-full bg-[#AC3F1E] text-white uppercase tracking-wide py-3 font-semibold hover:opacity-90 transition disabled:opacity-60"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
